export { cardVariables as cardHeaderVariables } from './cardVariables';
